// GENERATED FILE - DO NOT MODIFY

export enum ServiceRequestStatusDto {
    Open = "Open",
    Closed = "Closed",
}